export default {
  atoms: {
    adSlot: {
      adLabel: 'Advertisement'
    },
    authSupportCopy: {
      copy: 'Need any further assistance? We can help.',
      action: 'Email us at'
    },
    premiumIdentifier: {
      iconText: 'Premium'
    },
    recaptchaCopy: {
      agreeLineOne: 'This site is protected by reCAPTCHA and the Google',
      agreeLineTwo: 'Privacy Policy',
      agreeLineThree: 'and',
      agreeLineFour: 'Terms of Service',
      agreeLineFive: 'apply.',
      ariaLabel: {
        privacy: 'privacy policy',
        terms: 'terms of service'
      }
    },
    termsAndConditions: {
      agreeLineOne: 'By creating an account, you agree to the',
      agreeLineTwo: 'terms',
      agreeLineThree: 'and',
      agreeLineFour: 'privacy policy',
      agreeLineFive: 'of Immediate Media Company Limited. You can opt out from emails at any time.',
      ariaLabel: {
        privacy: 'privacy policy',
        terms: 'terms and conditions'
      }
    },
    time: {
      // v4 plural
      formatTimeHours_one: '{{hours}} hr',
      formatTimeHours_few: '{{hours}} hrs',
      formatTimeHours_many: '{{hours}} hrs',
      formatTimeHours_other: '{{hours}} hrs',
      // v3 plural
      formatTimeHours: '{{hours}} hr',
      formatTimeHours_plural: '{{hours}} hrs',
      formatTimeHours_0: '{{hours}} hr',
      formatTimeHours_1: '{{hours}} hrs',
      formatTimeHours_2: '{{hours}} hrs',
      // v4 plural
      formatTimeMins_one: '{{minutes}} min',
      formatTimeMins_few: '{{minutes}} mins',
      formatTimeMins_many: '{{minutes}} mins',
      formatTimeMins_other: '{{minutes}} mins',
      // v3 plural
      formatTimeMins: '{{minutes}} min',
      formatTimeMins_plural: '{{minutes}} mins',
      formatTimeMins_0: '{{minutes}} min',
      formatTimeMins_1: '{{minutes}} mins',
      formatTimeMins_2: '{{minutes}} mins'
    },
    instagramEmbed: {
      viewPostOnInstagram: 'View post on Instagram'
    }
  },
  molecules: {
    accountNav: {
      defaultLabel: 'My Account',
      registerText: 'Register',
      signInText: 'Sign in',
      ariaLabel: {
        account: 'Account'
      }
    },
    adBanner: {
      ariaLabel: {
        dismissText: 'Dismiss ad banner'
      }
    },
    ageVerificationModal: {
      title: 'Age Verification',
      intro: 'This site contains content intended for adults only',
      deny: 'I\'m not over {{ageLimit}}',
      confirm: 'I\'m over {{ageLimit}}',
      moreInfo: 'More information',
      remember: 'Remember me.'
    },
    authDropDown: {
      registerText: 'Register',
      signInText: 'Sign in'
    },
    batchedGrid: {
      showingItemsText: 'Showing items 1 to {{nItemsShown}} of {{nItems}}',
      viewMoreButtonText: 'View more',
      showMoreButtonsText: 'Show more'
    },
    cookAndPrepTime: {
      sr: {
        timeRange: 'Preparation and cooking time'
      },
      timeRange: {
        cook: 'Cook:',
        prep: 'Prep:',
        total: 'Total time'
      }
    },
    eyebrowNav: {
      ariaLabel: {
        quickLinks: 'Quick links'
      }
    },
    formAutoComplete: {
      ariaLabel: {
        noResult: 'No result',
        search: 'Search'
      }
    },
    formImageUpload: {
      button: {
        loadPrompt: 'Tap or click to add photo',
        loadPromptRequired: 'required',
        loadPromptOptional: 'optional',
        ownImage: '*Please ensure this is your own image',
        remove: 'Remove',
        rotateLeft: 'Rotate left',
        rotateRight: 'Rotate right',
        save: 'Save'
      },
      error: {
        maxFileSize: 'Filesize is too large, please upload an image smaller than {{maxFileSize}}MB',
        minHeight: 'Image does not meet the minimum height requirement of {{minDimensions}}px',
        minWidth: 'Image does not meet the minimum width requirement of {{minDimensions}}px'
      }
    },
    formMultiSelect: {
      ariaLabel: {
        formInput: 'Filter {{label}}'
      },
      filterOptions: {
        noResult: 'No results',
        selectAllLabel: 'Select All',
        inputPlaceholderSelect: 'Select...',
        inputPlaceholderSelected: 'selected'
      },
      sr: {
        optionsButton: 'Toggle options display'
      }
    },
    formSortableInputs: {
      ariaLabel: {
        deleteInput: 'Delete',
        grab: 'Grab to move input'
      }
    },
    formSubmitButton: {
      button: {
        savedText: 'Saved',
        savingText: 'Saving'
      }
    },
    gallery: {
      ariaLabel: {
        fullScreen: 'open gallery in fullscreen'
      },
      imgCountText: '{{slideCount}} of {{images}}'
    },
    glossaryNav: {
      ariaLabel: {
        nav: 'glossary'
      }
    },
    heightClamper: {
      button: {
        expandTextMore: 'Show more',
        expandTextLess: 'Show less'
      }
    },
    ingredientsList: {
      heading: 'Ingredients'
    },
    inlineGallery: {
      imageCount: '{{imageCount}} of {{totalImages}}'
    },
    keyValueBlocks: {
      keyHeader: 'Key',
      prefixHeader: 'Highlight',
      valueHeader: 'Value'
    },
    lightBox: {
      ariaLabel: {
        close: 'close'
      }
    },
    loadingIcon: {
      sr: {
        icon: 'Loading'
      }
    },
    loadingState: {
      "default": {
        heading: 'One moment please...'
      },
      createAccount: {
        heading: 'Hold on tight!',
        subHeading: 'We\'re setting up your account'
      },
      logout: {
        heading: 'One moment please...',
        subHeading: 'Just logging you out.'
      }
    },
    methodList: {
      methodLabel: 'Method',
      counterPrefix: 'STEP'
    },
    modal: {
      ariaLabel: {
        close: 'Close modal'
      }
    },
    numericPaginator: {
      icon: {
        prev: 'Prev',
        next: 'Next'
      },
      sr: {
        icon: 'Page',
        nav: 'You\'re currently on page {{page}}'
      }
    },
    passwordCriteria: {
      ariaLabel: {
        notSatisfied: 'is not satisfied',
        satisfied: 'is satisfied'
      },
      config: {
        bothCase: 'Lowercase and uppercase letters',
        lowerCase: 'Lowercase letters',
        // v4 plural
        minLength_one: 'At least {{minLength}} character',
        minLength_few: 'At least {{minLength}} characters',
        minLength_many: 'At least {{minLength}} characters',
        minLength_other: 'At least {{minLength}} characters',
        // v3 plural
        minLength: 'At least {{minLength}} character',
        minLength_plural: 'At least {{minLength}} characters',
        minLength_0: 'At least {{minLength}} character',
        minLength_1: 'At least {{minLength}} characters',
        minLength_2: 'At least {{minLength}} characters',
        requireDigit: 'A number (i.e. 0–9)',
        symbol: 'A symbol (e.g. !, ?, @)',
        upperCase: 'Uppercase letters'
      },
      passwordContain: {
        text: 'Your password must contain'
      },
      sr: {
        passwordContain: 'Your password must contain:'
      }
    },
    passwordInput: {
      buttonText: {
        hide: 'HIDE',
        show: 'SHOW'
      },
      formLabel: 'Password',
      placeholder: 'Enter your password',
      sr: {
        strength: 'Password strength is {{passwordStrength}}',
        visibility: {
          hidden: 'Password hidden',
          shown: 'Password shown'
        }
      }
    },
    plantOverview: {
      averageYield: 'Average Yield:',
      depth: 'Depth:',
      size: 'Plant size:',
      spacing: 'Spacing:',
      spacingApart: '{{spacingApart}} apart',
      spacingBetween: '{{spacingBetweenRows}} between rows'
    },
    popupToggleButton: {
      ariaLabel: {
        toggle: 'Toggle {{popup}} popup'
      }
    },
    postContentStream: {
      ariaMessage: {
        itemsAdded: 'New items added at',
        singleItemAdded: 'New item added at'
      }
    },
    postTeaser: {
      readMore: 'Read more',
      publishDate: 'Published: {{published}}'
    },
    rate: {
      sr: {
        legend: 'What is your star rating out of {{bestRating}}?',
        outOf: 'out of',
        // v4 plural
        star_one: 'star',
        star_few: 'stars',
        star_many: 'stars',
        star_other: 'stars',
        // v3 plural
        star: 'star',
        star_plural: 'stars',
        star_0: 'star',
        star_1: 'stars',
        star_2: 'stars'
      }
    },
    rating: {
      ariaLabel: {
        rating: 'rating'
      },
      countText: '{{count}} {{label}}',
      types: {
        // v4 plural
        rating_one: 'rating',
        rating_few: 'ratings',
        rating_many: 'ratings',
        rating_other: 'ratings',
        // v3 plural
        rating: 'rating',
        rating_plural: 'ratings',
        rating_0: 'rating',
        rating_1: 'ratings',
        rating_2: 'ratings',
        // v4 plural
        review_one: 'review',
        review_few: 'reviews',
        review_many: 'reviews',
        review_other: 'reviews',
        // v3 plural
        review: 'review',
        review_plural: 'reviews',
        review_0: 'review',
        review_1: 'reviews',
        review_2: 'reviews'
      },
      inlineRateText: 'Rate',
      skeletonRateText: 'Rate'
    },
    ratingsCriteria: {
      overallLabel: 'Overall Rating'
    },
    searchForm: {
      ariaLabel: {
        performSearch: 'Perform search',
        resetButton: 'Reset input'
      }
    },
    sideBarNav: {
      ariaLabel: {
        settings: 'My settings',
        verticalNav: 'Side'
      }
    },
    socialShare: {
      sr: {
        iconEmail: 'Email to a friend',
        iconShare: 'Share on {{platform}}'
      }
    },
    socialSignInButton: {
      signUpWithButtonText: 'Sign up with',
      continueWithButtonText: 'Continue with'
    },
    tableClamper: {
      collapseButtonText: 'Show less',
      expandButtonText: 'Show more'
    },
    truncatedIcons: {
      tooltipLabel: 'more'
    }
  },
  organisms: {
    emailSentConfirmation: {
      accountVerificationHeading: 'We have sent a verification email to ',
      passwordResetHeading: 'If you have an account, you\'ll receive an email to reset your password.',
      resendEmailCopy: 'Didn\'t receive the email? ',
      bodyCopy: 'Please be sure to check all folders in your inbox, including spam.',
      resendEmailButton: 'Click to resend',
      supportEmailSubject: 'I need help with verifying my account.'
    },
    cardBuilder: {
      ariaLabel: {
        mediaImage: 'View {{title}}'
      },
      offerCodeText: 'use code: {{offerCode}}'
    },
    cardCarouselSection: {
      errorMessage: 'Uh oh, something went wrong while loading the data. Please try another option.',
      formLabel: 'Options',
      infoMessage: 'Sorry, there are no data available.',
      slidesToShowItems: 'Showing items {{currentSlide}} to {{nextSlides}} of {{allSlides}}',
      slidesToShowItem: 'Showing item {{currentSlide}} of {{allSlides}}'
    },
    carousel: {
      sr: {
        iconStack: '{{direction}} item',
        paging: 'Page {{pageNumber}}'
      }
    },
    resetPasswordForm: {
      headingCopy: 'My account:',
      submitButton: 'Submit password'
    },
    collection: {
      ariaLabel: {
        edit: 'Edit',
        registerButton: 'Register',
        share: 'Share',
        signinButton: 'Sign in'
      },
      author: '{{author}}',
      signinLinkText: 'Sign in',
      signInLinkTitle: 'Sign in',
      signInPromptLineOne: 'Is this your collection?',
      signInPromptLineTwo: 'to edit'
    },
    dynamicAccordian: {
      // v4 plural
      nextLabel_one: 'Show next {{count}} item',
      nextLabel_few: 'Show next {{count}} items',
      nextLabel_many: 'Show next {{count}} items',
      nextLabel_other: 'Show next {{count}} items',
      // v3 plural
      nextLabel: 'Show next {{count}} item',
      nextLabel_plural: 'Show next {{count}} items',
      nextLabel_0: 'Show next {{count}} item',
      nextLabel_1: 'Show next {{count}} items',
      nextLabel_2: 'Show next {{count}} items',
      // v4 plural
      previousLabel_one: 'Show previous {{count}} item',
      previousLabel_few: 'Show previous {{count}} items',
      previousLabel_many: 'Show previous {{count}} items',
      previousLabel_other: 'Show previous {{count}} items',
      // v3 plural
      previousLabel: 'Show previous {{count}} item',
      previousLabel_plural: 'Show previous {{count}} items',
      previousLabel_0: 'Show previous {{count}} item',
      previousLabel_1: 'Show previous {{count}} items',
      previousLabel_2: 'Show previous {{count}} items'
    },
    embeddedPost: {
      ariaLabel: {
        viewArticle: 'View {{title}}'
      }
    },
    filters: {
      ariaLabel: {
        activeFilters: 'Active filters',
        closeFilters: 'Close filters sidebar',
        refine: 'Refine',
        showMoreFilters: 'Show more filters',
        clearFiltersText: 'Clear all filters'
      },
      button: {
        clearFiltersText: 'Clear',
        refineText: 'Refine',
        showMoreFiltersText: 'More filters',
        closeText: 'Close'
      },
      clearAll: 'Clear all',
      refineText: 'Refine your results',
      yourFilters: 'Your filters:',
      sr: {
        closeFilters: 'Close filters sidebar'
      }
    },
    listPage: {
      showMoreButtonsText: 'Load more'
    },
    liveBlog: {
      errorMessage: 'Sorry, something went wrong while loading more items, please try again.',
      isLiveUpdatedText: 'LIVE updated {{duration}}',
      liveIconTitle: 'live',
      liveKickerTitle: 'Live',
      loadMoreButtonText: 'Load more',
      notLiveUpdatedText: 'Updated {{duration}}',
      statusText: 'Live coverage of this event has now concluded',
      time: {
        // v4 plural
        lessThanOneHour_one: '{{count}} minute ago',
        lessThanOneHour_few: '{{count}} minutes ago',
        lessThanOneHour_many: '{{count}} minutes ago',
        lessThanOneHour_other: '{{count}} minutes ago',
        // v3 plural
        lessThanOneHour: '{{count}} minute ago',
        lessThanOneHour_plural: '{{count}} minutes ago',
        lessThanOneHour_0: '{{count}} minute ago',
        lessThanOneHour_1: '{{count}} minutes ago',
        lessThanOneHour_2: '{{count}} minutes ago',
        lessThanOneMinute: 'less than 1 minute ago',
        // v4 plural
        moreThanHour_one: '{{count}} hour ago',
        moreThanHour_few: '{{count}} hours ago',
        moreThanHour_many: '{{count}} hours ago',
        moreThanHour_other: '{{count}} hours ago',
        // v3 plural
        moreThanHour: '{{count}} hour ago',
        moreThanHour_plural: '{{count}} hours ago',
        moreThanHour_0: '{{count}} hour ago',
        moreThanHour_1: '{{count}} hours ago',
        moreThanHour_2: '{{count}} hours ago'
      }
    },
    loginLanding: {
      button: {
        loginText: 'Log in with your email'
      },
      link: {
        createAccountText: 'Create an account'
      },
      dividerText: 'OR',
      newHereText: 'New here?',
      loginHeaderText: 'Hello again. You\'ve been missed, we\'re glad you\'re back.'
    },
    loginForm: {
      emailLabel: 'Email',
      emailPlaceholder: 'Enter your email',
      loginFormHeaderText: 'Enter your details to log in to your account',
      button: {
        loginText: 'Log in'
      },
      link: {
        forgotPasswordText: 'Forgot Password?'
      }
    },
    mainNav: {
      ariaLabel: {
        main: 'Main'
      },
      sr: {
        tierThreeBack: 'Back to',
        tierTwoBack: 'Back to'
      }
    },
    marketingPreferencesForm: {
      button: {
        saveMyPreferencesText: 'Save my preferences'
      },
      checkbox: {
        label: 'Yes, sign me up'
      },
      heading: 'Would you like to receive offers from {{brand}} and its publisher Immediate Media Company Limited?',
      notification: {
        error: 'We\'ve been unable to save your preferences. Please visit My Account and update your settings.'
      }
    },
    newsLetterSignUp: {
      input: {
        emailPlaceholder: 'Email address'
      }
    },
    post: {
      ariaLabel: {
        calloutButtonEdit: 'Edit',
        calloutButtonPublish: 'Publish'
      },
      productSpec: {
        collapseButtonText: 'Fewer details',
        expandButtonText: 'More details',
        headline: 'Product Specifications',
        skip: 'Skip to view product specifications'
      },
      sr: {
        sponsoredHeading: 'Sponsored content'
      }
    },
    postHeader: {
      button: {
        dealsText: 'Skip to view deals',
        print: 'Print'
      },
      itemCount: {
        // v3 plural
        items_one: 'item',
        items_few: 'items',
        items_many: 'items',
        items_other: 'items',
        // v4 plural
        items: 'item',
        items_plural: 'items',
        items_0: 'item',
        items_1: 'items',
        items_2: 'items'
      },
      ourRatingText: 'Our Rating',
      publishDate: 'Published: {{published}}'
    },
    reaction: {
      ariaLabel: {
        "delete": 'Delete'
      },
      button: {
        replyText: 'Reply',
        reportText: 'Report'
      },
      removedText: 'This has been removed'
    },
    registrationForm: {
      createText: 'Create an account',
      emailPlaceholder: 'Enter your email',
      srButton: 'button.',
      emailLabel: 'Email'
    },
    registrationLanding: {
      ariaLabel: {
        signUpText: 'Click here to sign up with your email'
      },
      button: {
        signUpText: 'Sign up with your email'
      },
      link: {
        loginText: 'Log in'
      },
      dividerText: 'OR',
      alreadyRegisteredText: 'Already registered?',
      registrationHeaderText: 'Create your {{brand}} account and receive our exclusive email newsletters.'
    },
    forgottenPasswordForm: {
      formCopy: 'Enter your registered email address and we\'ll help you reset your password.',
      emailLabel: 'Email',
      emailPlaceholder: 'Enter your email',
      resetPasswordButtonText: 'Reset Password'
    },
    reviewSummary: {
      heading: 'What we tested'
    },
    roastCalculator: {
      button: {
        resetText: 'Reset'
      },
      imperialLabel: 'Imperial',
      metricLabel: 'Metric',
      sr: {
        imperialValueOunces: 'Imperial value in ounces',
        imperialValuePounds: 'Imperial value in pounds',
        metricConverterLabel: 'Metric value in {{unit}}',
        metricConverterUnit: '{{converter}} unit',
        selectMeat: 'Select meat'
      },
      meat: {
        beefMedium: 'Beef (medium)',
        beefRare: 'Beef (rare)',
        beefWellDone: 'Beef (well done)',
        chicken: 'Chicken',
        duck: 'Duck',
        goose: 'Goose',
        lambMedium: 'Lamb (medium)',
        lambRare: 'Lamb (rare)',
        lambWellDone: 'Lamb (well done)',
        pork: 'Pork',
        turkey: 'Turkey',
        venisonMedium: 'Venison (medium)',
        venisonRare: 'Venison (rare)',
        venisonWellDone: 'Venison (well done)'
      }
    },
    searchResults: {
      button: {
        loadPrevious: 'Load previous',
        loadNext: 'Load next'
      },
      showingItems: 'Showing {{from}} to {{to}} of {{total}} results',
      noResults: 'Sorry, something went wrong while loading the search results, please try again.'
    },
    siteFooter: {
      privacyItemLabel: 'Manage Privacy Settings',
      privacyItemTitle: 'Manage your privacy and consent settings'
    },
    verificationError: {
      errorWithRetrySignUpCopy: 'We\'ve encountered an issue when attempting to verify your account. Try registering again or contact support.',
      errorWithResendEmailCopy: 'Sorry about that! Try clicking below to send a new verification email.',
      linkExpiredWithResendEmailCopy: 'The link we sent you is no longer valid, we do this to keep your account secure. Click below to send a new verification email.',
      supportEmailSubject: 'I need help with verifying my account.'
    },
    weightVolumeConverter: {
      ariaLabel: {
        imperialValue: 'Imperial value in {{units}}',
        imperialValueOther: 'Imperial value in {{units}}',
        metricUnitText: 'metric unit selection',
        metricValueText: 'Metric value'
      },
      sr: {
        imperialValue: 'Imperial value in {{units}}',
        imperialValueOther: 'Imperial value in {{units}}',
        metricUnitText: 'Metric unit',
        metricValueText: 'Metric value'
      },
      volumeText: 'Volume',
      weightText: 'Weight'
    }
  },
  templates: {
    searchPage: {
      title: 'Your search results',
      noResults: 'Sorry we couldn\'t find any results. Please try updating your search term.',
      error: 'Sorry, there was an issue loading the search results.',
      sort: 'Sort'
    }
  }
};